// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar container */
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 64px;
  background: #163968;
  display: flex;
  flex-direction: column;
  transition: width 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 2000;
  overflow: hidden;
  border-right: none;
}

.sidebar.open {
  width: 220px;
}

.sidebar.collapsed {
  width: 64px;
}

/* Header / logo area */
.sidebar-header {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;  /* ← add this */
  padding: 0 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
  overflow: hidden;
}

.sidebar-logo {
  height: 70px;
  width: 70px;
  max-width: 140px;
  object-fit: contain;
  opacity: 0;
  transition: opacity 0.2s ease;
  flex-shrink: 0;
}

.sidebar.open .sidebar-logo {
  opacity: 1;
}

/* Collapsed icon shown when sidebar is closed */
.sidebar-icon-placeholder {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.sidebar.open .sidebar-icon-placeholder {
  display: none;
}

/* Scrollable nav area */
.menu {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 12px 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  -webkit-overflow-scrolling: touch;
}

/* Each nav button */
.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  background: transparent;
  color: rgba(255, 255, 255, 0.55);
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  width: 100%;
  white-space: nowrap;
  transition: background 0.15s ease, color 0.15s ease;
  position: relative;
}

.menu-item:hover {
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.85);
}

.menu-item.active {
  background: rgba(99, 102, 241, 0.2);
  color: #a5b4fc;
  font-weight: 500;
}

/* Active left accent bar */
.menu-item.active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 20%;
  height: 60%;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: #818cf8;
}

/* Icon inside menu item */
.icon {
  font-size: 16px;
  min-width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-left: 2px;
  color: inherit;
  transition: color 0.15s ease;
}

.menu-item.active .icon {
  color: #818cf8;
}

/* Label text */
.text {
  white-space: nowrap;
  overflow: hidden;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.sidebar.open .text {
  opacity: 1;
}

/* Bottom user section */
.sidebar-footer {
  padding: 12px 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
}

.sidebar-user {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  border-radius: 8px;
  overflow: hidden;
}

.sidebar-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  flex-shrink: 0;
}

.sidebar-user-info {
  overflow: hidden;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.sidebar.open .sidebar-user-info {
  opacity: 1;
}

.sidebar-username {
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
  white-space: nowrap;
}

.sidebar-role {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.4);
  white-space: nowrap;
}

/* Hamburger (kept but hidden — hover expand replaces it) */
.hamburger {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/css/Sidebar.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,oDAAoD;EACpD,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB,GAAG,eAAe;EACzC,eAAe;EACf,kDAAkD;EAClD,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA,gDAAgD;AAChD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iCAAiC;AACnC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,UAAU;EACV,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;AACf","sourcesContent":["/* Sidebar container */\r\n.sidebar {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  height: 100vh;\r\n  width: 64px;\r\n  background: #163968;\r\n  display: flex;\r\n  flex-direction: column;\r\n  transition: width 0.25s cubic-bezier(0.4, 0, 0.2, 1);\r\n  z-index: 2000;\r\n  overflow: hidden;\r\n  border-right: none;\r\n}\r\n\r\n.sidebar.open {\r\n  width: 220px;\r\n}\r\n\r\n.sidebar.collapsed {\r\n  width: 64px;\r\n}\r\n\r\n/* Header / logo area */\r\n.sidebar-header {\r\n  height: 64px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;  /* ← add this */\r\n  padding: 0 16px;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\r\n  flex-shrink: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.sidebar-logo {\r\n  height: 70px;\r\n  width: 70px;\r\n  max-width: 140px;\r\n  object-fit: contain;\r\n  opacity: 0;\r\n  transition: opacity 0.2s ease;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.sidebar.open .sidebar-logo {\r\n  opacity: 1;\r\n}\r\n\r\n/* Collapsed icon shown when sidebar is closed */\r\n.sidebar-icon-placeholder {\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 8px;\r\n  background: rgba(255, 255, 255, 0.08);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.sidebar.open .sidebar-icon-placeholder {\r\n  display: none;\r\n}\r\n\r\n/* Scrollable nav area */\r\n.menu {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  padding: 12px 8px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n/* Each nav button */\r\n.menu-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 10px 12px;\r\n  border-radius: 8px;\r\n  border: none;\r\n  cursor: pointer;\r\n  background: transparent;\r\n  color: rgba(255, 255, 255, 0.55);\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  text-align: left;\r\n  width: 100%;\r\n  white-space: nowrap;\r\n  transition: background 0.15s ease, color 0.15s ease;\r\n  position: relative;\r\n}\r\n\r\n.menu-item:hover {\r\n  background: rgba(255, 255, 255, 0.06);\r\n  color: rgba(255, 255, 255, 0.85);\r\n}\r\n\r\n.menu-item.active {\r\n  background: rgba(99, 102, 241, 0.2);\r\n  color: #a5b4fc;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Active left accent bar */\r\n.menu-item.active::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  top: 20%;\r\n  height: 60%;\r\n  width: 3px;\r\n  border-radius: 0 3px 3px 0;\r\n  background: #818cf8;\r\n}\r\n\r\n/* Icon inside menu item */\r\n.icon {\r\n  font-size: 16px;\r\n  min-width: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  margin-left: 2px;\r\n  color: inherit;\r\n  transition: color 0.15s ease;\r\n}\r\n\r\n.menu-item.active .icon {\r\n  color: #818cf8;\r\n}\r\n\r\n/* Label text */\r\n.text {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  opacity: 0;\r\n  transition: opacity 0.15s ease;\r\n}\r\n\r\n.sidebar.open .text {\r\n  opacity: 1;\r\n}\r\n\r\n/* Bottom user section */\r\n.sidebar-footer {\r\n  padding: 12px 8px;\r\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.sidebar-user {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 8px 12px;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n}\r\n\r\n.sidebar-avatar {\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 50%;\r\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #fff;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.sidebar-user-info {\r\n  overflow: hidden;\r\n  opacity: 0;\r\n  transition: opacity 0.15s ease;\r\n}\r\n\r\n.sidebar.open .sidebar-user-info {\r\n  opacity: 1;\r\n}\r\n\r\n.sidebar-username {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: rgba(255, 255, 255, 0.85);\r\n  white-space: nowrap;\r\n}\r\n\r\n.sidebar-role {\r\n  font-size: 11px;\r\n  color: rgba(255, 255, 255, 0.4);\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Hamburger (kept but hidden — hover expand replaces it) */\r\n.hamburger {\r\n  display: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
